<template lang="pug">
.nav-header-content
    a-modal(title="重置密码" 
        v-if="!!me"
        @ok="submitChangePass"
        @cancel="resetPassVisible=false"
        :closable="!me.shouldResetPassword"
        :visible="resetPassVisible || me.shouldResetPassword")
        a-form(:form="changePassForm")
            a-form-item(label="新密码")
                a-input(type='password' v-decorator="['newPassword',{rules: [{required: true}]}]")

    a-dropdown
        .nav-item(@click="e => e.preventDefault()")
            a-icon(type="menu" )

        a-menu(slot="overlay")
            a-menu-item(v-for="i in $perms" 
                :key="i.value" 
                @click="goto(i.value, i.label)"
                v-if="me&& me.perms.includes(i.value) && !i.invisiable")
                my-icon(v-if="i.iconCustom" :type="i.iconType")
                a-icon(v-if="!i.iconCustom" :type="i.iconType")
                span {{ i.label }}
                
        //- a-icon(:type="collapsed ? 'menu' : 'menu'")
    
    .title {{navTitle}}
    .empty
    //- .nav-item(@click="goto('market', '行情')")
    //-     a-icon(type="stock")
    .nav-item(@click="goto('admin', '管理员')"
        v-if="me && me.perms.includes('admin')")
        a-icon(type="setting")

    .nav-item(@click="openNotificationDrawer")
        a-badge(:count="unreadCount" :overflow-count="99" :show-zero="false")
            a-icon(type="message" style="font-size: 20px;")

    .nav-item(@click="goto('market', '交易系统')")
        a-icon(type="sliders")
        span(style="font-size:14px;margin-left: 5px") 行情系统

    .nav-item(@click="goto('trade', '交易系统')")
        a-icon(type="fund")
        span(style="font-size:14px;margin-left: 5px") 交易系统

    .nav-item(@click="goto('folders', '文件系统')")
        a-icon(type="database")
        span(style="font-size:14px;margin-left:5px") 文件系统
        
    .nav-item 
        a-dropdown
            span(@click="e => e.preventDefault()")
                a-icon(type='user')
                span(style="margin: 0 5px") {{me && me.name}}
                a-icon(type="down")

            a-menu(slot="overlay" @click="handelUserMenu")
                a-menu-item(key="resetPass")
                    a-icon(type='key')
                    span 修改密码
                a-menu-item(key="logout")
                    a-icon(type="logout")
                    span 退出

    a-drawer(title="通知"
        placement="right"
        :width="360"
        :visible="notificationDrawerVisible"
        @close="notificationDrawerVisible=false")
        a-spin(:spinning="notificationLoading")
            a-list(item-layout="vertical" :dataSource="notifications" :locale="{emptyText: '暂无新通知'}")
                a-list-item(slot="renderItem" slot-scope="item, index" @click="handleNotificationClick(item, index)" style="cursor: pointer; padding: 8px 0;")
                    a-list-item-meta
                        span(slot="title")
                            span {{ item.title }}
                            a-tag(:color="levelColor(item.level)" style="margin-left: 8px") {{ levelLabel(item.level) }}
                        div(slot="description")
                            div {{ item.content }}
                            div(style="color: #cfcff1; font-size: 12px; margin-top: 4px;") {{ formatTime(item.createdAt) }}
</template>

<script>
import { mapState } from 'vuex';
import MyIcon from './MyIcon';
import _ from 'lodash';

export default {
    data() {

        return {
            collapsed: false,
            changePassForm: this.$form.createForm(this, {name: 'resetForm'}),
            resetPassVisible: false,
            notificationDrawerVisible: false,
            notificationLoading: false,
            notifications: [],
            notificationPollTimer: null,
        }
    },
    methods: {
        goto(key, title) {
            this.title = title;
            this.$router.replace(`/main/${key}`);
            // this.$store.commit('nav/setVisible', false);
        },
        collapsedToggle() {
            this.collapsed = !this.collapsed;
        },
        handelUserMenu(e) {
            if (e.key == 'logout') {
                this.logout();
            }
            else if (e.key == 'resetPass') {
                this.resetPassVisible = true;
            }
        },
        logout() {
            this.$api.request('POST', 'logout').then(() => {
                this.$store.commit('user/setMe', null);
                this.$router.replace('/login');
            });
        },
        submitChangePass() {
            this.changePassForm.validateFields((error, values) => {
                if (!error) {
                    if (values.newPassword.length < 6) {
                        this.$message.error('密码长度最少6位！');
                        return;
                    }

                    this.$api
                        .request('POST', 'resetPass', {
                            password: values.newPassword,
                        })
                        .then(() => {
                            this.resetPassVisible = false;
                            this.$message.success('修改成功');
                        });
                }
            });
        },
        openNotificationDrawer() {
            if (!this.me) {
                return;
            }

            this.notificationDrawerVisible = true;
            this.loadNotifications();
        },
        async loadNotifications() {
            if (!this.me) {
                this.notifications = [];
                return;
            }

            this.notificationLoading = true;
            try {
                const res = await this.$api.request('GET', 'notifies');
                const list = res.data;
                this.notifications = Array.isArray(list) ? list : [];
            }
            catch (e) {
                console.error('加载通知失败', e);
            }
            finally {
                this.notificationLoading = false;
            }
        },
        async handleNotificationClick(item, index) {
            this.notifications.splice(index, 1);
            try {
                const id = item.id || item._id;
                if (id) {
                    await this.$api.request('POST', `notify/done/${id}`, {});
                }
            }
            catch (e) {
                console.error('标记通知已读失败', e);
            }
        },
        levelColor(level) {
            const mapping = {
                info: 'blue',
                warning: 'orange',
                danger: 'red',
            };
            return mapping[level] || 'blue';
        },
        levelLabel(level) {
            const mapping = {
                info: '信息',
                warning: '警告',
                danger: '危险',
            };
            return mapping[level] || level;
        },
        formatTime(date) {
            if (!date) {
                return '';
            }
            const d = new Date(date);
            if (Number.isNaN(d.getTime())) {
                return date;
            }
            const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
        },
        startNotificationPolling() {
            this.stopNotificationPolling();
            this.notificationPollTimer = setInterval(() => {
                if (this.me && this.isWithinNotifyWindow()) {
                    this.loadNotifications();
                }
            }, 15000);
        },
        stopNotificationPolling() {
            if (this.notificationPollTimer) {
                clearInterval(this.notificationPollTimer);
                this.notificationPollTimer = null;
            }
        },
        isWithinNotifyWindow() {
            const hour = new Date().getHours();
            return hour >= 9 && hour < 20;
        }
    },
    computed: {
        ...mapState('user', ['me', 'navTitle']),
        unreadCount() {
            return this.notifications.length;
        }
    },
    watch: {
        me: {
            immediate: true,
            handler(v) {
                if (v) {
                    this.loadNotifications();
                    this.startNotificationPolling();
                }
                else {
                    this.notificationDrawerVisible = false;
                    this.notifications = [];
                    this.stopNotificationPolling();
                }
            }
        }
    },
    beforeDestroy() {
        this.stopNotificationPolling();
    },
    components: {
        MyIcon,
    },
}
</script>


<style lang="less" scoped>
.nav-header-content {
    color: white;
    height: 40px;
    background-color: #292961;
    width: 100%;
    border-bottom: solid 1px gray;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 10px;
    .collapse-menu {
        font-size: 30px;
        
    }
    .empty {
        flex: 1;
    }

    .title {
        margin-left: 10px;
    }

    .nav-item {
        margin: 2px 5px;
        padding: 0 10px;
        font-size: 20px;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        background-color: #71719e;
        :hover {
            border-radius: 0px;
        }
    }
}
</style>
